// export const Baseurl = "http://localhost:4085";
// export const Baseurl2 = "http://localhost:4085";

export const Baseurl = "https://mygoldenhomeswebsiteapi.bayfikar.in";
export const Baseurl2 = "https://mygoldenhomeswebsiteapitwo.bayfikar.in";